import React, { useState, useEffect } from "react";
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import api from "../../../services/api";
import { useSnackbarAlert } from "../../../hooks/useSnackbarAlert";
import { isValidName, isValidEmail } from "../../../utils/validation";

const EditMemberModal = ({ open, onClose, member, onSuccess }) => {
  const snackbar = useSnackbarAlert();

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
  });

  useEffect(() => {
    if (member) {
      setFormData({
        firstName: member.firstName || "",
        lastName: member.lastName || "",
        email: member.email || "",
        phone: member.phone !== "unknown" ? member.phone : "",
      });
    }
  }, [member]);

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async () => {
    const { firstName, lastName, email, phone } = formData;

    if (!isValidName(firstName) || !isValidName(lastName)) {
      snackbar.error("First and last name must be valid and cannot be empty.");
      return;
    }

    if (!isValidEmail(email)) {
      snackbar.error("Please enter a valid email address.");
      return;
    }

    if (phone && !/^\d{10}$/.test(phone)) {
      snackbar.error("Phone number must be exactly 10 digits.");
      return;
    }

    try {
      await api.put(`/admin/digitalLoyalty/${member._id}`, formData);
      snackbar.success("Member updated successfully");
      onSuccess();
      onClose();
    } catch (err) {
      const message = err?.response?.data?.message || "Update failed";
      snackbar.error(message);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
        }}>
        <IconButton
          sx={{ position: "absolute", top: 8, right: 8 }}
          onClick={onClose}>
          <CloseIcon />
        </IconButton>
        <Typography variant="h6" sx={{ mb: 3, fontWeight: "bold" }}>
          Edit Member
        </Typography>

        <TextField
          label="First Name"
          fullWidth
          sx={{ mb: 2 }}
          value={formData.firstName}
          onChange={(e) => handleChange("firstName", e.target.value)}
        />
        <TextField
          label="Last Name"
          fullWidth
          sx={{ mb: 2 }}
          value={formData.lastName}
          onChange={(e) => handleChange("lastName", e.target.value)}
        />
        <TextField
          label="Email"
          fullWidth
          sx={{ mb: 2 }}
          value={formData.email}
          onChange={(e) => handleChange("email", e.target.value)}
        />
        <TextField
          label="Phone Number"
          fullWidth
          sx={{ mb: 2 }}
          value={formData.phone}
          onChange={(e) => handleChange("phone", e.target.value)}
        />

        <Button
          fullWidth
          variant="contained"
          color="primary"
          onClick={handleSubmit}>
          Save Changes
        </Button>
      </Box>
    </Modal>
  );
};

export default EditMemberModal;
